module.exports = __webpack_public_path__ + "img/alert-triangle.8c623db9.svg";